const DayCountConventionType = Object.freeze({
  THIRTY_360: "30/360",
  THIRTY_365: "30/365",
  ACTUAL_360: "Actual/360",
  ACTUAL_365: "Actual/365",
  ACTUAL_ACTUAL: "Actual/Actual",
});

export default DayCountConventionType;
